import { render, staticRenderFns } from "./HostingAddonsView.vue?vue&type=template&id=d73625ac&"
import script from "./HostingAddonsView.vue?vue&type=script&lang=js&"
export * from "./HostingAddonsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d73625ac')) {
      api.createRecord('d73625ac', component.options)
    } else {
      api.reload('d73625ac', component.options)
    }
    module.hot.accept("./HostingAddonsView.vue?vue&type=template&id=d73625ac&", function () {
      api.rerender('d73625ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/common/HostingAddonsView.vue"
export default component.exports